import { toastController } from "@ionic/vue";

/*
    * Alternative to the useToasts composable, to better usable independently of the vue/vuex context.
*/
export const presentToast = async (message: string, duration = 2000) => {
    const toast = await toastController
        .create({
            message,
            duration,
            cssClass: "toastStyle"
        });

    // according to https://github.com/ionic-team/ionic-framework/issues/22704
    const active = await toastController.getTop();

    if (active) {
        await active.dismiss();
    }

    return toast.present();
};

